const initialState = {
    loading: false,
    paymentData: {},
    couponData: {},
    error: '',
}

const PaymentReducer = (state = initialState, action) => {
    switch(action.type){
        case 'PAYMENT_LOADING':
            return {
                ...state,
                loading: action.payload
            }
        case 'GET_COUPON_SUCCESS':
            return{
                ...state,
                loading: false,
                couponData: action.payload
            }
        case 'GET_COUPON_FAILURE':
            return{
                ...state,
                loading: false,
                error:action.payload
            }
        case 'GET_PAYMENT_SUCCESS':
            return{
                ...state,
                loading: false,
                paymentData: action.payload
            }
        case 'GET_PAYMENT_FAILURE':
            return{
                ...state,
                loading: false,
                error:action.payload
            }
        default: return state
    }
}

export default PaymentReducer